import {connect} from 'react-redux';
import {findSection} from 'ducks/reportSections';
import CustomiseNzTitles from './CustomiseNzTitles';

const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  const section = findSection(state.reportSections, reportType, 'NZ_TITLES');
  const {
    titles, disclaimers
  } = state.nzTitles;

  return {
    section,
    reportType,
    titles,
    disclaimers,
  };
};

export default connect(mapStateToProps)(CustomiseNzTitles);
